(function(){
    'use strict';

    angular
    .module('app')
    .controller('FieldsController', FieldsController)
 
    FieldsController.$inject = ["FieldsService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function FieldsController(FieldsService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.fieldConfig = "";
        vm.id_type = "";
        vm.type = "";
        vm.jsonValue = "";
        vm.loadTypes = function(){
        	FieldsService.getConfigfield(vm.type,vm.id_type,function(data){
                $timeout(function(){
                    var dataJson = JSON.parse(data);
                    vm.fieldConfig = dataJson.html;
                })
            });
        }
        vm.initConfig = function(id){
            vm.id_type = id;
            vm.type = $('#fieldconfig-type').val();
        	/*$("#fieldconfig-node_type").on("change",function(event) {
				vm.loadTypes();
			});*/
			vm.loadTypes();
        }
    } 

})();